/* PRFORM v4 homepage scripts. Generated from seed-structure/index.html on 2026-09-15. Each piece checks for its element and stays quiet if it is not on the page. */
(function(){
  var c=document.getElementById('orb'); if(!c) return;
  var ctx=c.getContext('2d'), DPR=Math.min(window.devicePixelRatio||1,1.5), W=0,H=0;
  var REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* simplex noise 3D (Gustavson), seeded permutation */
  var grad3=[[1,1,0],[-1,1,0],[1,-1,0],[-1,-1,0],[1,0,1],[-1,0,1],[1,0,-1],[-1,0,-1],[0,1,1],[0,-1,1],[0,1,-1],[0,-1,-1]];
  var p=[],i; for(i=0;i<256;i++) p[i]=i; var seed=7; function rnd(){ seed=(seed*16807)%2147483647; return (seed-1)/2147483646; }
  for(i=255;i>0;i--){ var j=Math.floor(rnd()*(i+1)), t=p[i]; p[i]=p[j]; p[j]=t; }
  var perm=new Uint8Array(512), pm=new Uint8Array(512); for(i=0;i<512;i++){ perm[i]=p[i&255]; pm[i]=perm[i]%12; }
  var F3=1/3, G3=1/6;
  function noise(x,y,z){ var n0,n1,n2,n3; var s=(x+y+z)*F3, i=Math.floor(x+s), j=Math.floor(y+s), k=Math.floor(z+s), t=(i+j+k)*G3;
    var x0=x-(i-t), y0=y-(j-t), z0=z-(k-t), i1,j1,k1,i2,j2,k2;
    if(x0>=y0){ if(y0>=z0){i1=1;j1=0;k1=0;i2=1;j2=1;k2=0;} else if(x0>=z0){i1=1;j1=0;k1=0;i2=1;j2=0;k2=1;} else {i1=0;j1=0;k1=1;i2=1;j2=0;k2=1;} }
    else { if(y0<z0){i1=0;j1=0;k1=1;i2=0;j2=1;k2=1;} else if(x0<z0){i1=0;j1=1;k1=0;i2=0;j2=1;k2=1;} else {i1=0;j1=1;k1=0;i2=1;j2=1;k2=0;} }
    var x1=x0-i1+G3, y1=y0-j1+G3, z1=z0-k1+G3, x2=x0-i2+2*G3, y2=y0-j2+2*G3, z2=z0-k2+2*G3, x3=x0-1+3*G3, y3=y0-1+3*G3, z3=z0-1+3*G3;
    var ii=i&255, jj=j&255, kk=k&255, g;
    var t0=.6-x0*x0-y0*y0-z0*z0; if(t0<0) n0=0; else { g=grad3[pm[ii+perm[jj+perm[kk]]]]; t0*=t0; n0=t0*t0*(g[0]*x0+g[1]*y0+g[2]*z0); }
    var t1=.6-x1*x1-y1*y1-z1*z1; if(t1<0) n1=0; else { g=grad3[pm[ii+i1+perm[jj+j1+perm[kk+k1]]]]; t1*=t1; n1=t1*t1*(g[0]*x1+g[1]*y1+g[2]*z1); }
    var t2=.6-x2*x2-y2*y2-z2*z2; if(t2<0) n2=0; else { g=grad3[pm[ii+i2+perm[jj+j2+perm[kk+k2]]]]; t2*=t2; n2=t2*t2*(g[0]*x2+g[1]*y2+g[2]*z2); }
    var t3=.6-x3*x3-y3*y3-z3*z3; if(t3<0) n3=0; else { g=grad3[pm[ii+1+perm[jj+1+perm[kk+1]]]]; t3*=t3; n3=t3*t3*(g[0]*x3+g[1]*y3+g[2]*z3); }
    return 32*(n0+n1+n2+n3); }
  window.__noise3=noise;
  /* particle strand: a filament of fine points advected by curl noise, long trails, additive glow.
     After the TouchDesigner references (Guevara particle smoke, "Trajectory"): white on black, one hue in the accent. */
  var N=innerWidth<700?7000:16000, PX=new Float32Array(N), PY=new Float32Array(N), PL=new Float32Array(N), PA=new Float32Array(N), PC=new Uint8Array(N);
  var ACC='141,176,127'; window.__setOrb=function(rgb){ ACC=rgb; };
  var GC=18, gcols=0, grows=0, VX=null, VY=null;
  function size(){ var rect=c.getBoundingClientRect(); W=Math.max(1,Math.round(rect.width*DPR)); H=Math.max(1,Math.round(rect.height*DPR)); c.width=W; c.height=H; gcols=Math.ceil(W/(GC*DPR))+2; grows=Math.ceil(H/(GC*DPR))+2; VX=new Float32Array(gcols*grows); VY=new Float32Array(gcols*grows); ctx.fillStyle='#050506'; ctx.fillRect(0,0,W,H); }
  size(); addEventListener('resize',size);
  function spine(x,t){ return H*0.46+Math.sin(x/W*3.4+t*0.9)*H*0.07+Math.sin(x/W*9.1-t*0.6)*H*0.025; }
  function gauss(){ return (Math.random()+Math.random()+Math.random()-1.5)*1.2; }
  function spawn(i,t){ var x=Math.random()*W; PX[i]=x; PY[i]=spine(x,t)+gauss()*11*DPR; PL[i]=80+Math.random()*320; PA[i]=0; PC[i]=Math.random()<0.16?1:0; }
  var t0=performance.now(); for(i=0;i<N;i++){ spawn(i,0); PA[i]=Math.random()*PL[i]; }
  function field(t){ var sc=1/(Math.max(W,H)*0.9), e=0.6; for(var j=0;j<grows;j++) for(var i2=0;i2<gcols;i2++){ var x=i2*GC*DPR*sc, y=j*GC*DPR*sc; /* curl of a scalar field: divergence-free, so the strands stay coherent */ var n1=noise(x*1.5,y*1.5+e*sc,t)+0.5*noise(x*5.5,y*5.5+e*sc,t*1.6), n2=noise(x*1.5,y*1.5-e*sc,t)+0.5*noise(x*5.5,y*5.5-e*sc,t*1.6), n3=noise(x*1.5+e*sc,y*1.5,t)+0.5*noise(x*5.5+e*sc,y*5.5,t*1.6), n4=noise(x*1.5-e*sc,y*1.5,t)+0.5*noise(x*5.5-e*sc,y*5.5,t*1.6); var k=j*gcols+i2; VX[k]=(n1-n2)/(2*e*sc)*0.00023; VY[k]=-(n3-n4)/(2*e*sc)*0.00023; } }
  var lastF=0, fcount=0;
  function frame(now){
    var t=(now-t0)*0.00012;
    if(fcount%2===0) field(t*0.9); fcount++;
    ctx.globalCompositeOperation='source-over'; ctx.fillStyle='rgba(5,5,6,.09)'; ctx.fillRect(0,0,W,H);
    ctx.globalCompositeOperation='lighter';
    var s1=1*DPR, s2=2.2*DPR, cw=GC*DPR;
    for(var pass=0;pass<2;pass++){
      var col=pass?ACC:'237,237,234';
      ctx.fillStyle='rgba('+col+','+(pass?0.22:0.16)+')';
      for(i=0;i<N;i++){ if(PC[i]!==pass) continue;
        var x=PX[i], y=PY[i], fx=Math.min(gcols-1.001,Math.max(0,x/cw)), fy=Math.min(grows-1.001,Math.max(0,y/cw)), gi=fx|0, gj=fy|0, tx=fx-gi, ty=fy-gj, k=gj*gcols+gi;
        var vx=((VX[k]*(1-tx)+VX[k+1]*tx)*(1-ty)+(VX[k+gcols]*(1-tx)+VX[k+gcols+1]*tx)*ty)*W, vy=((VY[k]*(1-tx)+VY[k+1]*tx)*(1-ty)+(VY[k+gcols]*(1-tx)+VY[k+gcols+1]*tx)*ty)*W;
        /* a weak pull back to the spine keeps it a strand instead of fog */
        var sy=spine(x,t), dy=sy-y, band=22*DPR; if(Math.abs(dy)>band) vy+=(dy-(dy>0?band:-band))*0.006; vx+=0.6*DPR;
        x+=vx; y+=vy; PA[i]+=1;
        if(PA[i]>PL[i]||x<-10||x>W+10||y<-10||y>H+10){ spawn(i,t); x=PX[i]; y=PY[i]; }
        PX[i]=x; PY[i]=y;
        var life=PA[i]/PL[i], sz=(life<0.15||life>0.85)?s1:s1;
        ctx.fillRect(x,y,sz,sz);
      }
      /* a sparse second layer of larger, softer points for glow */
      ctx.fillStyle='rgba('+col+','+(pass?0.05:0.035)+')';
      for(i=0;i<N;i+=7){ if(PC[i]!==pass) continue; ctx.fillRect(PX[i]-s2/2,PY[i]-s2/2,s2,s2); }
    }
    ctx.globalCompositeOperation='source-over';
    if(!REDUCED) requestAnimationFrame(frame);
  }
  window.__stepOrb=function(n){ var now=performance.now(); for(var q=0;q<n;q++){ REDUCED=true; frame(now+q*16.7); } REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches; };
  requestAnimationFrame(frame);
})();

(function(){
  /* the living knit: a sheet of stitches seen at an angle, rippling like cloth and breathing on a slow cycle.
     Where the knit opens, the stitches take the accent, the mesh opening where you heat up. Ink on the page ground. */
  var c=document.getElementById('obj'); if(!c) return;
  var ctx=c.getContext('2d'), DPR=Math.min(window.devicePixelRatio||1,1.5), W=0,H=0, noise=window.__noise3;
  var REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ACC='79,115,70'; window.__setWord=function(rgb){ ACC=rgb; };
  var COLS=innerWidth<700?64:96, ROWS=innerWidth<700?52:78, N=COLS*ROWS, U=new Float32Array(N), V=new Float32Array(N), i;
  for(var r=0;r<ROWS;r++) for(var q=0;q<COLS;q++){ i=r*COLS+q; U[i]=(q/(COLS-1))*2-1; V[i]=(r/(ROWS-1))*2-1; }
  function size(){ var rect=c.getBoundingClientRect(); W=Math.max(1,Math.round(rect.width*DPR)); H=Math.max(1,Math.round(rect.height*DPR)); c.width=W; c.height=H; }
  size(); addEventListener('resize',size);
  var mx=0,my=0,tx=0,ty=0; addEventListener('pointermove',function(e){ tx=(e.clientX/innerWidth-.5)*.35; ty=(e.clientY/innerHeight-.5)*.25; },{passive:true});
  var BUCK=6, EDG=4, lists=[]; for(i=0;i<BUCK*2*EDG;i++) lists.push([]);
  var t0=performance.now();
  function frame(now){
    var T=(now-t0)*0.001, t=T*0.11, breath=0.5-0.5*Math.cos(T*(2*Math.PI/5.2));   /* 5.2 s in and out */
    mx+=(tx-mx)*.04; my+=(ty-my)*.04;
    var ax=0.95+my, az=-0.22+mx, cx=Math.cos(ax), sx=Math.sin(ax), cz=Math.cos(az), sz=Math.sin(az);
    var R=Math.min(W,H)*0.8, ox=W/2, oy=H*0.5, k, open=1+0.07*breath;
    for(k=0;k<lists.length;k++) lists[k].length=0;
    for(i=0;i<N;i++){
      var u=U[i]*open, v=V[i]*open, rr=u*u+v*v; if(rr>1.02) continue;
      var n=noise(u*1.4+t, v*1.4-t*0.6, t*0.8), n2=noise(u*3.6-t*0.9, v*3.6+t*0.4, t*1.3);
      var z=(0.16*n+0.05*n2+0.10*breath*(1-rr))*R;           /* ripple plus a breathing lift in the middle */
      var x=u*R*0.95, y=v*R*0.8;
      var x1=x*cz-y*sz, y1=x*sz+y*cz;                        /* turn */
      var y2=y1*cx-z*sx, z2=y1*sx+z*cx;                      /* tilt */
      var f=1/(1.6-z2/R*0.5), px=ox+x1*f, py=oy+y2*f;
      var edge=rr<0.55?1:Math.max(0,1-(rr-0.55)/0.47), depth=(z2/R+1)/2, b=Math.min(BUCK-1,Math.max(0,Math.floor(depth*BUCK)));
      var hot=(n>0.22-0.18*breath)?1:0;                       /* the knit opens where it is warm; more of it on the in-breath */
      var el=Math.min(EDG-1,Math.floor(edge*EDG)); if(edge<=0.02) continue;
      lists[(b*2+hot)*EDG+el].push(px,py,f);
    }
    ctx.clearRect(0,0,W,H);
    for(k=0;k<lists.length;k++){ var L=lists[k]; if(!L.length) continue; var bh=Math.floor(k/EDG), el2=k%EDG, bkt=Math.floor(bh/2), hot2=bh%2; var ef=(el2+1)/EDG; var a=(0.22+0.66*Math.pow(bkt/(BUCK-1),1.3))*ef; var col=hot2?ACC:'12,12,13';
      ctx.fillStyle='rgba('+col+','+a.toFixed(3)+')'; var sz2=(1.3+1.7*bkt/(BUCK-1))*DPR*(0.6+0.4*ef);
      for(var q=0;q<L.length;q+=3){ var f2=L[q+2]; ctx.fillRect(L[q],L[q+1],sz2*f2,sz2*f2); } }
    if(!REDUCED) requestAnimationFrame(frame);
  }
  window.__stepWord=function(n,offsetMs){ var now=t0+(offsetMs||0); for(var q=0;q<n;q++){ REDUCED=true; frame(now+q*16.7); } REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches; };
  requestAnimationFrame(frame);
})();

(function(){
  
  var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });},{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  function sweep(){ document.querySelectorAll('.rv:not(.in)').forEach(function(el){ var r=el.getBoundingClientRect(); if(r.bottom>0&&r.top<innerHeight) el.classList.add('in'); }); }
  setTimeout(sweep,300); addEventListener('load',sweep); var swT=0; addEventListener('scroll',function(){ var n=Date.now(); if(n-swT>120){ swT=n; sweep(); } },{passive:true}); setTimeout(function(){ document.querySelectorAll('.hero .rv').forEach(function(el){el.classList.add('in')}); },2000);

  var cio=new IntersectionObserver(function(es){es.forEach(function(e){ e.target.classList.toggle('in-view', e.isIntersecting); });},{threshold:.55});
  document.querySelectorAll('.pcard').forEach(function(el){cio.observe(el)});

  var vio=new IntersectionObserver(function(es){es.forEach(function(e){ var v=e.target; if(v.closest('.film__slide')) return; e.isIntersecting? v.play().catch(function(){}) : v.pause(); });},{threshold:.3});
  document.querySelectorAll('video').forEach(function(v){vio.observe(v)});

  if(document.querySelector('.film__slide')){
  /* film carousel: centred active slide, neighbours peek (Seed: swiper centeredSlides) */
  var slides=[].slice.call(document.querySelectorAll('.film__slide')), thumbs=[].slice.call(document.querySelectorAll('.film__thumb')), idx=0, n=slides.length, t0=0, DUR=6000;
  function layout(){
    var w=slides[0].offsetWidth, gap=16;
    slides.forEach(function(s,i){
      var d=i-idx; if(d>n/2) d-=n; if(d<-n/2) d+=n;
      s.style.transform='translateX(calc(-50% + '+(d*(w+gap))+'px))';
      s.style.opacity=Math.abs(d)>1?0:1; s.style.zIndex=d===0?2:1;
      s.classList.toggle('is-active',d===0);
      var v=s.querySelector('video'); if(v){ d===0? v.play().catch(function(){}) : v.pause(); }
    });
    thumbs.forEach(function(t,i){ t.classList.toggle('is-active',i===idx); t.style.setProperty('--p',0); });
  }
  function go(k){ idx=(k+n)%n; layout(); t0=performance.now(); }
  function tick(now){ var p=Math.min(1,(now-t0)/DUR); thumbs[idx].style.setProperty('--p',p); if(p>=1){ go(idx+1); } requestAnimationFrame(tick); }
  document.getElementById('filmPrev').onclick=function(){go(idx-1)};
  document.getElementById('filmNext').onclick=function(){go(idx+1)};
  thumbs.forEach(function(t,i){ t.onclick=function(){go(i)}; });
  slides.forEach(function(s,i){ s.addEventListener('click',function(ev){ if(i!==idx){ ev.preventDefault(); go(i);} }); });
  addEventListener('resize',layout); go(0); requestAnimationFrame(tick);

  }
  /* the fibre: one merino strand as a twisted bundle of fine filaments, turning with the scroll, with fly-aways.
     Ink on the page ground, a few filaments in the accent. Replaces the blurred SVG strand from the theme. */
  (function(){
    var c=document.getElementById('pfFibStage'); if(!c) return;
    var ctx=c.getContext('2d'), DPR=Math.min(window.devicePixelRatio||1,1.5), W=0,H=0, noise3=null;
    var REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ACC='79,115,70'; window.__setFibre=function(deep){ /* kept for the accent hook */ };
    var M=54, SEG=96, TH=new Float32Array(M), OFF=new Float32Array(M), MOSS=new Uint8Array(M), i;
    for(i=0;i<M;i++){ TH[i]=(i/M)*Math.PI*2+Math.random()*0.06; OFF[i]=Math.random()*10; MOSS[i]=(i%9===4)?1:0; }
    var FLY=520, FX=new Float32Array(FLY), FT=new Float32Array(FLY), FA=new Float32Array(FLY), FR=new Float32Array(FLY), FS=new Float32Array(FLY);
    for(i=0;i<FLY;i++){ FT[i]=Math.random(); FA[i]=Math.random()*Math.PI*2; FR[i]=1.15+Math.random()*1.6; FS[i]=0.0006+Math.random()*0.0012; FX[i]=Math.random(); }
    var K=7.1;
    function size(){ var r=c.getBoundingClientRect(); W=Math.max(1,Math.round(r.width*DPR)); H=Math.max(1,Math.round(r.height*DPR)); c.width=W; c.height=H; }
    size(); addEventListener('resize',size);
    function centre(t,phase){ var amp=W*0.16*Math.pow(Math.sin(Math.PI*t),0.35); return {x:W*0.5+Math.sin(t*K+0.5+phase*0.35)*amp, y:H*0.06+H*0.88*t}; }
    function widthAt(t){ return W*0.008+W*0.165*Math.pow(Math.sin(Math.PI*t),0.7); }
    var sec=document.getElementById('pfFib'), pr=0, drawn=-1, idle=0, lastNow=0;
    function onScroll(){ var r=sec.getBoundingClientRect(); pr=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height))); }
    var order=[]; for(i=0;i<M;i++) order.push(i);
    function frame(now){
      if(!noise3) noise3=window.__noise3;
      var dt=lastNow?Math.min(50,now-lastNow):16; lastNow=now; if(!REDUCED) idle+=dt*0.00012;
      var twist=pr*1.2*Math.PI*2+idle, tt=now*0.0002;
      ctx.clearRect(0,0,W,H);
      /* shading by depth: sort the filaments back to front */
      var dep=new Float32Array(M), j;
      for(j=0;j<M;j++) dep[j]=Math.sin(TH[j]+twist*1.0);
      order.sort(function(a,b){ return dep[a]-dep[b]; });
      for(var oi=0;oi<M;oi++){ j=order[oi];
        var d=(dep[j]+1)/2;                        /* 0 back, 1 front */
        ctx.beginPath();
        for(var k=0;k<=SEG;k++){ var t=k/SEG, p=centre(t,twist), p2=centre(Math.min(t+0.01,1),twist), tx=p2.x-p.x, ty=p2.y-p.y, tl=Math.sqrt(tx*tx+ty*ty)||1, nx=-ty/tl, ny=tx/tl;
          var ang=TH[j]+twist+t*9.5;                /* the wind: each filament spirals along the strand */
          var r=widthAt(t)*Math.cos(ang), wob=(noise3?noise3(t*3+OFF[j],j*0.2,tt):0)*W*0.012;
          var x=p.x+nx*(r+wob), y=p.y+ny*(r+wob);
          if(k===0) ctx.moveTo(x,y); else ctx.lineTo(x,y); }
        var a=0.08+0.62*Math.pow(d,1.8), col=MOSS[j]?ACC:'12,12,13';
        ctx.strokeStyle='rgba('+col+','+a.toFixed(3)+')'; ctx.lineWidth=(0.6+1.1*d)*DPR; ctx.stroke();
      }
      /* fly-aways: loose fibre ends drifting off the surface */
      ctx.fillStyle='rgba(12,12,13,.35)';
      for(i=0;i<FLY;i++){ var t2=FT[i], p3=centre(t2,twist), q=centre(Math.min(t2+0.01,1),twist), tx2=q.x-p3.x, ty2=q.y-p3.y, tl2=Math.sqrt(tx2*tx2+ty2*ty2)||1, nx2=-ty2/tl2, ny2=tx2/tl2;
        var rr=widthAt(t2)*FR[i]*Math.cos(FA[i]+twist+t2*9.5), x3=p3.x+nx2*rr, y3=p3.y+ny2*rr, fade=Math.max(0,1-(FR[i]-1.15)/1.6);
        ctx.globalAlpha=fade*0.9; ctx.fillRect(x3,y3,1*DPR,1*DPR);
        FT[i]+=FS[i]; if(FT[i]>1){ FT[i]=0; FA[i]=Math.random()*Math.PI*2; FR[i]=1.15+Math.random()*1.6; } }
      ctx.globalAlpha=1;
      if(!REDUCED) requestAnimationFrame(frame);
    }
    addEventListener('scroll',onScroll,{passive:true}); addEventListener('resize',onScroll,{passive:true}); onScroll();
    window.__stepFibre=function(n,scrollFrac){ if(scrollFrac!==undefined) pr=scrollFrac; for(var q=0;q<n;q++){ REDUCED=true; frame(1000+q*16.7); } REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches; };
    if(REDUCED){ frame(1000); return; }
    requestAnimationFrame(frame);
  })();

  var strip=document.querySelector('.strip');
  if(strip){
  /* strip: drag to scroll */
  var down=false, sx=0, sl=0;
  strip.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse') return; down=true; sx=e.clientX; sl=strip.scrollLeft; });
  addEventListener('pointermove',function(e){ if(!down) return; strip.scrollLeft=sl-(e.clientX-sx); });
  addEventListener('pointerup',function(){ down=false; });
  }
})();

/* PF4 header: glass after 40px of scroll, mobile drawer */
(function(){
  var h=document.getElementById('pf4Hdr'); if(!h) return;
  var html=document.documentElement;
  function onScroll(){ html.classList.toggle('with-little-scrolled', window.scrollY>40); }
  addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var b=document.getElementById('pf4Burger'), d=document.getElementById('pf4Drawer');
  if(b&&d) b.addEventListener('click',function(){ var open=h.classList.toggle('is-open'); b.setAttribute('aria-expanded',open?'true':'false'); d.setAttribute('aria-hidden',open?'false':'true'); document.body.style.overflow=open?'hidden':''; });
})();
